import { ServiceProviderConfig, ServiceProviderConfigResponse } from '../types/ServiceProviderConfig';
import { ScimAuthService } from './ScimAuthService';
import { getScimConfig } from '../utils/envUtils';
import { debugLog } from '../utils/debugLog';

export class ServiceProviderConfigService {
    private baseUrl: string;

    constructor() {
        // Get SCIM API configuration from environment variables
        const scimConfig = getScimConfig();
        this.baseUrl = scimConfig.apiUrl;
    }

    /**
     * Get authentication token for API calls
     */
    private async getAuthToken(): Promise<string> {
        return ScimAuthService.getAuthToken();
    }

    /**
     * Get Service Provider Configuration
     */
    public async getServiceProviderConfig(): Promise<ServiceProviderConfig> {
        try {
            debugLog('🔧 ServiceProviderConfigService: Fetching service provider configuration...');

            const token = await this.getAuthToken();
            const response = await fetch(`${this.baseUrl}/ServiceProviderConfig`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            debugLog('🔧 ServiceProviderConfigService: Received service provider configuration:', data);

            return data;
        } catch (error) {
            console.error('❌ ServiceProviderConfigService: Error fetching service provider configuration:', error);
            throw error;
        }
    }

    /**
     * Get Service Provider Configuration with error handling
     */
    public async getServiceProviderConfigSafe(): Promise<ServiceProviderConfig | null> {
        try {
            return await this.getServiceProviderConfig();
        } catch (error) {
            console.error('❌ ServiceProviderConfigService: Failed to fetch service provider configuration:', error);
            return null;
        }
    }
}
